import {Collection, FetchResponse} from "@alpha-nft/marketplace-models";
import {marketplaceServerUrl} from "../lib/utils";

export async function search(search: string): Promise<FetchResponse<Collection>> {
    const sp = new URLSearchParams();
    sp.set('q', search)
    return (await fetch(`${marketplaceServerUrl()}/search?${sp.toString()}`)).json();
}